import AvailabilityCheckInput from './AvailabilityCheckInput'

export default AvailabilityCheckInput
